/* unplugin-vue-components disabled */import { render } from "./message-api.vue?vue&type=template&id=1064ada8"
import script from "./message-api.vue?vue&type=script&lang=js"
export * from "./message-api.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/prod.front.you18.www.prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__